export default "__VITE_ASSET__BXPP3PhM__"